"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { formEditTableFormShowTable } from "Actions/Forms/FormEditTableActions";
import { tbSetDefaultButtonsState } from "Actions/Table/TableToolBarActions";
import { Messages } from "Messages";

var RefreshButtonProp =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(RefreshButtonProp, _BaseToolbarButtonPro);

  function RefreshButtonProp(_ref) {
    var _this;

    var formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu,
        title = _ref.title,
        rest = _objectWithoutProperties(_ref, ["formUUID", "isContextMenu", "title"]);

    _classCallCheck(this, RefreshButtonProp);

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: title || Messages.Controls.Refresh,
      hint: title || Messages.Controls.Refresh,
      elementAttr: {
        'class': "table-form-refresh-button"
      },
      onClick: function onClick(e) {
        setTimeout(function () {
          _this.UUID = _this._isContextMenu ? _this._props.UUID : _this._props.options.UUID;
          formEditTableFormShowTable(false, _this.UUID);
          formEditTableFormShowTable(true, _this.UUID);
          tbSetDefaultButtonsState(_this.UUID);
        });
      }
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RefreshButtonProp).call(this, props));
    isContextMenu ? _this._props.UUID = formUUID : _this._props.options.UUID = formUUID;

    _this.setOptions({
      iconType: _this.getOptions().iconType || 'material:refresh'
    });

    return _this;
  }

  return RefreshButtonProp;
}(BaseToolbarButtonProp);

_defineProperty(RefreshButtonProp, "create", function (options) {
  return new RefreshButtonProp(options).props();
});

export { RefreshButtonProp as default };